import { render } from "./AccordionGroup.vue?vue&type=template&id=47f0e5b6"
import script from "./AccordionGroup.vue?vue&type=script&lang=js"
export * from "./AccordionGroup.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__